// extracted by css-extract-rspack-plugin
export default {"Box":"ExportSponsorships-module__Box__JTdbN","Text":"ExportSponsorships-module__Text__Q4w5L","Button":"ExportSponsorships-module__Button__mimeL"};